export const getEffectiveMaxQuantity = (
  maxQuantity: number = 0,
  stockLevel?: number
): number => {
  if (stockLevel === undefined || stockLevel === null) {
    return maxQuantity
  }
  return Math.min(maxQuantity, stockLevel)
}

export const isMinQuantityExceedsStock = (
  minQuantity: number = 0,
  stockLevel?: number
): boolean => {
  if (stockLevel === undefined || stockLevel === null) {
    return false
  }
  return minQuantity > stockLevel
}

export const getOrderQuantityValues = (
  minQuantity: number = 0,
  maxQuantity: number = 0,
  stockLevel?: number
) => {
  const effectiveMax = getEffectiveMaxQuantity(maxQuantity, stockLevel)

  if (effectiveMax < minQuantity) {
    return []
  }

  return Array.from({ length: effectiveMax - minQuantity + 1 }, (_, k) => {
    const number = k + minQuantity

    return {
      value: `${number}`,
      text: `${number}`
    }
  })
}
